import {styled} from "@mui/material/styles";
import {Typography} from "@mui/material";

/**
 * @deprecated
 */
export const LocationCardRowLabel = styled(Typography)(() => ({
  color: "rgba(0, 0, 0, 0.6)",
  fontSize: "14px",
  fontWeight: 400,
  fontFamily: "Inter",
  textTransform: "uppercase",
  lineHeight: "1.43em",
  letterSpacing: "0.01em",
}));

/**
 * @deprecated
 */
export const LocationCardRowValue = styled(Typography)(() => ({
  textTransform: "capitalize",
  fontSize: "16px",
  fontWeight: 500,
  lineHeight: "1.43em",
  letterSpacing: "0.01em",
  overflowWrap: "break-word",
}));
